// Core
import { call, put } from 'redux-saga/effects';
import { Map } from 'immutable';

// Instruments
import { compareActions as actions } from 'bus/compare/actions';
import { compareStorage as storage } from 'bus/compare/storage';


export function* loadLocalComparedWorker () {
    try {
        const compared = yield call([storage, 'findAll']);

        if (compared) {
            yield put(
                actions.loadLocalComparedSuccess(
                    Map(compared)
                        .filter((notempty) => notempty)
                        .toList()
                ));
        }
    } catch (error) {
        yield put(actions.loadLocalComparedFail(error));
    }
}
